import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantOnlinePaymentConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantOnlinePaymentConfigEntity
